<template>
<div class="addCommentWrapper marginBottom">
          <h3>{{ msg }}</h3>
     <div class="row">
      <div class="col-md-12">
         <b-form-input
              ref="comment"
              v-model = "comment"
              type="text"
              required
              placeholder="Kommentar"
            />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label>Ladda upp en bild
          <input type="file" id="file" ref="file" v-on:change="handleFileUpload()"/>
        </label>
        <img style="max-width: 150px" :src="image"/>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label>Kvittens
          <input type="checkbox" v-model="receipt"/>
        </label>
      </div>
    </div>
        <div class="row">
      <div class="col-md-12">
        <button class="btn btn-primary" v-on:click="onSubmit()">Spara</button>
      </div>
    </div>
</div>
</template>

<script>
import { bus } from '../../main'
export default {
  name: 'CommentCreate',
  data () {
    return {
      msg: 'Lägg till kommentar',
      comment: '',
      file: '',
      image: '',
      receipt: false
    }
  },
  props: {
    objectId: String
  },
  methods: {
    onSubmit () {
      if (this.file !== '') {
        var url = '/api/images'
        this.$http
          .post(url, this.file, {
            headers: {
              'Content-Disposition': 'attachment; filename=' + this.file.name,
              'Content-Type': 'image/jpeg'
            }
          })
          .then(response => {
            this.image = response.data.imageUrl
            this.$http
              .post('/api/comments', { comment: {imageId: response.data.imageId, userId: localStorage.getItem('userId'), objectId: this.$props.objectId, text: this.comment, receipt: this.receipt} })
              .then(response => {
                bus.$emit('addedComment', response.data)
              })
              .catch(error => console.log(error))
          })
          .catch(error => console.log(error))
      } else {
        this.$http
          .post('/api/comments', { comment: {imageId: null, userId: localStorage.getItem('userId'), objectId: this.$props.objectId, text: this.comment, receipt: this.receipt} })
          .then(response => {
            bus.$emit('addedComment', response.data)
          })
          .catch(error => console.log(error))
      }
    },
    clearFiles () {
      this.$refs.fileinput.reset()
    },
    handleFileUpload () {
      this.file = this.$refs.file.files[0]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Comments/CommentCreate.vue